module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAVCAYAAACkCdXRAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAALEgAACxIB0t1+/AAAAAd0SU1FB90CHAQFJTMBlsgAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAGHRFWHRTb2Z0d2FyZQBwYWludC5uZXQgNC4wLjOM5pdQAAAAsklEQVQ4T6XPwQ3DIAwFULhUitSJOkl36AZdKdfu0nMn6AhUFjV8bOMQ+UtfBIJenKSTS28ouXy+79YRxg/IvRmNyRXv1L2b8bK18nPtYWyE144tJYTxyJG25HK/Xc0+H1vra7+YVZgEEcHa0IBR+LCiFkTViIIw8wn1RG76ZNZ0GpuCPsRdAMdf8zAqgh2dQGcxAOMYnbkYVSJeDzGsBWD/GCUGAsRZA2UNiEMvzpaT0g926BJmOdOn0gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./assets/icons/cooking-icon.png
// module id = 486
// module chunks = 0